import { Radio, LogOut } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";

export function Shell({ children, title }) {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#07090E] flex flex-col">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0F131C]/80 border-b border-[#1E2638]">
        <div className="px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3" data-testid="brand-logo">
            <div className="relative w-9 h-9 rounded-lg bg-emerald-500/10 border border-emerald-500/30 flex items-center justify-center">
              <Radio className="w-5 h-5 text-emerald-400" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-extrabold tracking-tight text-lg text-slate-100" style={{ fontFamily: "Outfit, sans-serif" }}>
                  Scharpz Live!
                </span>
                <span className="w-2 h-2 rounded-full bg-emerald-400 pulse-dot" data-testid="brand-live-dot" />
              </div>
              {title && <div className="ops-caption -mt-0.5">{title}</div>}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="text-right hidden sm:block">
              <div className="text-sm font-medium text-slate-200" data-testid="header-user-name">{user?.name || user?.username}</div>
              <div className="ops-caption" data-testid="header-user-role">{user?.role === "admin" ? "Administrator" : "Tenant"}</div>
            </div>
            <Button data-testid="logout-btn" variant="outline" size="sm" onClick={logout}
              className="border-[#1E2638] bg-transparent hover:bg-[#1E2638] text-slate-300">
              <LogOut className="w-4 h-4 sm:mr-1.5" />
              <span className="hidden sm:inline">Sign out</span>
            </Button>
          </div>
        </div>
      </header>
      <main className="px-4 sm:px-6 lg:px-8 py-6 max-w-7xl mx-auto flex-1 w-full">{children}</main>
      <footer className="border-t border-[#1E2638]" data-testid="app-footer">
        <div className="px-4 sm:px-6 lg:px-8 py-5 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <div className="flex items-center gap-2 text-[11px] font-mono uppercase tracking-widest text-slate-500">
            <span className="w-1.5 h-1.5 rounded-full bg-emerald-400 pulse-dot" />
            Scharpz Live! · SCHARPZ Limited
          </div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-slate-600 text-center" data-testid="footer-copyright">
            © {new Date().getFullYear()} SCHARPZ Limited · All rights reserved
            <span className="hidden md:inline text-slate-700"> · Unauthorized access is prohibited &amp; monitored</span>
          </div>
          <div className="text-[11px] font-mono uppercase tracking-widest text-slate-600" data-testid="footer-status">
            SYS.STATUS&nbsp;<span className="text-emerald-400">OPERATIONAL</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
